export function getTokenExpirationMs(token) {
  if (typeof token !== "string") return null;

  const parts = token.split(".");
  if (parts.length !== 3) return null;

  try {
    const base64Payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const missingPaddingLength = (4 - (base64Payload.length % 4)) % 4;
    const paddedPayload = base64Payload + "=".repeat(missingPaddingLength);
    const payload = JSON.parse(atob(paddedPayload));
    if (typeof payload?.exp !== "number") return null;
    return payload.exp * 1000;
  } catch {
    return null;
  }
}
